import * as constants from 'common/constants';

export const DEFAULT_STATE = {
  showMapFlag: false,
  fields: [],
};

export default (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case constants.FIELD_DISPLAY_TOGGLE:
      return {
        ...state,
        showMapFlag:
          payload && payload.hasOwnProperty('isOpen')
            ? payload.isOpen
            : !state.showMapFlag,
      };
    case constants.FIELD_LIST_SUCCESS:
      return {
        ...state,
        fields: payload.fields,
      };
    case constants.FIELD_CREATE_ERROR:
      return {
        ...state,
        error: payload.error,
      };
    case constants.REMOVE_LOCAL_FIELD:
      return {
        ...state,
        fields: state.fields.filter(
          ({ season, name }) =>
            !(season === payload.season && name === payload.name)
        ),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/field.js